import { Box, Card, Container, Grid, Typography } from "@mui/material";
import React from "react";
import Header from "src/Component/content-component/Header";
import IndiaWhyStudy from './WhyStudyInIndiaData'
import Tooltip from '@mui/material/Tooltip';


const imageBaseUrl = process.env.REACT_APP_IMAGE_URL
const Image1 = imageBaseUrl + "StydyUSA/image1.png";
const Image2 = imageBaseUrl + "StydyUSA/image2.png";
const Image3 = imageBaseUrl + "StydyUSA/image3.png";
const Image4 = imageBaseUrl + "StydyUSA/image4.png";
const Image5 = imageBaseUrl + "StydyUSA/image5.png";
// const Image6 = imageBaseUrl + "StydyUSA/image6.png";

const WhyStudyInIndia = () => {
  return (
    <Box mt={5} sx={{ background: "#EFFDFF" }}>
      <Container>
        <Grid>
          <Box 
            pt={10}
            pb={13}
            sx={{
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "none",
                xs: "none",
              },
              justifyContent: "center"
            }}
          >
            <Header
              content={IndiaWhyStudy?.title}
              textAlign={{ md: "center", sm: "center", xs: "center" }}
              sx={{mb:3}}
            />

          </Box>
          <Grid pb={10} item md={12} xs={12} n display={"flex"} justifyContent={"center"}>


            <Box >
              <Box
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                  border: "4px dashed whitesmoke",
                  height: { md: "500px" },
                  width: { md: "500px" },
                  borderRadius: "50%",
                  background: "#63D7DB",
                  position: "relative",
                  display: {
                    xl: "flex",
                    lg: "flex",
                    md: "flex",
                    sm: "none",
                    xs: "none",
                  },
                }}
              >
                <Box
                  sx={{
                    border: "4px dashed whitesmoke",
                    height: { md: "300px" },
                    width: { md: "300px" },
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      border: "1px solid whitesmoke",
                      height: { md: "150px" },
                      width: { md: "150px" },
                      borderRadius: "50%",
                      background: "whitesmoke",
                      boxShadow: "4px 7px 4px rgba(0,0,0,0.2)"
                    }}
                  >
                    <Card
                      sx={{
                        zIndex: "1",
                        borderRadius: "12px",
                        display: "flex",
                    
                        alignItems: "center",
                        flexDirection: "column",
                        position: "absolute",
                       
                         left: "30%", // Centering horizontally
                         top: "-65px", 
                        padding: "20px 0",
                        width: "180px",
                        height: "150px",
                      }}
                    >

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          width: "80px",
                          margin: "auto",
                        }}
                      >
                        <img src={Image1} alt="" width="70%" />
                      </Box>
                      <Typography   
                        sx={{
                          textAlign: "center",
                          fontSize: { xl: "13px", lg: "13px", md: "13px" }, fontWeight: 500,mx:'2px'
                        }}
                      > <Tooltip title={IndiaWhyStudy?.point1.subtitle} sx={{fontSize:20}} >
                        {IndiaWhyStudy?.point1.title}
                        </Tooltip>
                      </Typography>
                    </Card>
                    <Card
                      sx={{
                        zIndex: "1",
                        borderRadius: "12px",
                        display: "flex",
                  
                        alignItems: "center",
                        flexDirection: "column",
                        position: "absolute",
                     
                        right: "-90px", top: "100px",
                        width: "180px",
                        height: "150px", padding: "20px 0",

                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          width: "80px",
                          margin: "auto",
                        }}
                      >
                        <img src={Image2} alt="" width="70%" />
                      </Box>
                      <Typography 
                        sx={{
                          textAlign: "center",
                          fontSize: { xl: "13px", lg: "13px", md: "13px" }, fontWeight: 500,mx:'2px',
                        }}
                      >
                        <Tooltip title={IndiaWhyStudy?.point2.subtitle}>
                        {IndiaWhyStudy?.point2.title}

                        </Tooltip>
                      </Typography>
                    </Card>
                    <Card
                      sx={{
                        zIndex: "1",
                        borderRadius: "12px",
                        display: "flex",
                      
                        alignItems: "center",
                        flexDirection: "column",
                        position: "absolute",
                   
                        right: "-50px", bottom: "-10px", 
                        width: "180px",
                        height: "150px", padding: "20px 0",

                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          width: "80px",
                          margin: "auto",
                        }}
                      >
                        <img src={Image5} alt="" width="70%" />
                      </Box>
                      <Typography 
                        sx={{
                          textAlign: "center",
                          fontSize: { xl: "13px", lg: "13px", md: "13px" }, fontWeight: 500,mx:'2px',

                        }}
                      >
                        <Tooltip title={IndiaWhyStudy?.point5.subtitle}>
                        {IndiaWhyStudy?.point5.title}

                        </Tooltip>
                      </Typography>
                    </Card>
                  
                    <Card
                      sx={{
                        zIndex: "1",
                        borderRadius: "12px",
                        display: "flex",
                     
                        alignItems: "center",
                        flexDirection: "column",
                        position: "absolute",
               
                        left: "-50px", bottom: "-10px",
                        width: "180px",
                        height: "150px", padding: "20px 0",

                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          width: "80px",
                          margin: "auto",
                        }}
                      >
                        <img src={Image3} alt="" width="70%" />
                      </Box>
                      <Typography 
                        sx={{
                          textAlign: "center",
                          fontSize: { xl: "13px", lg: "13px", md: "13px" }, fontWeight: 500,mx:'2px',
                        }}
                      >
                        <Tooltip title={IndiaWhyStudy?.point3.subtitle}>
                        {IndiaWhyStudy?.point3.title}

                        </Tooltip>
                      </Typography>
                    </Card>
                    <Card
                      sx={{
                        zIndex: "1",
                        borderRadius: "12px",
                        display: "flex",
                        // justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        position: "absolute",
                        // right: "-120px",
                        left: "-90px", top: "100px",
                        width: "180px",
                        height: "150px", padding: "20px 0",

                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          width: "80px",
                          margin: "auto",
                        }}
                      >
                        <img src={Image4} alt="" width="70%" />
                      </Box>
                      <Typography 
                        sx={{
                          textAlign: "center",
                          fontSize: { xl: "13px", lg: "13px", md: "14px" }, fontWeight: 500,mx:'2px'
                        }}
                      >
                        <Tooltip title={IndiaWhyStudy?.point4.subtitle}>
                        {IndiaWhyStudy?.point4.title}

                        </Tooltip>
                      </Typography>
                    </Card>
                  </Box>
                </Box>
              </Box>
            </Box>

          </Grid>
        </Grid>
        <Grid item sm={12} xs={12} >
          <Box
            sx={{
              display: {
                xl: "none",
                lg: "none",
                md: "none",
                sm: "screen",
                xs: "screen",
              },
              justifyContent: "center"
            }}
          >
            <Header
              content={IndiaWhyStudy?.title}
              textAlign={{ md: "center", sm: "center", xs: "center" }}
            // fontSize={"36px"}
            />

          </Box>
          <Grid pt={5} item md={12} xs={12}>
            <Box sx={{}}>
              <Box
                sx={{
                  justifyContent: "center",
                  display: {
                    xl: "none",
                    lg: "none",
                    md: "none",
                    sm: "flex",
                    xs: "flex",
                  },
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Card
                  pb={5}
                  sx={{
                    zIndex: "1",
                    borderRadius: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "250px",
                    height: "180px",
                    marginBottom: "25px",
                    padding: "20px 5px"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: {
                        sm: "80px", xs: "80px"
                      },
                      margin: "auto",
                    }}
                  >
                    <img src={Image1} alt="" width="100%" />
                  </Box>
                  <Typography
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                      fontSize: { xl: "20px", lg: "12px", md: "13px", sm: "16px", xs: "16px" }, fontWeight: 500,
                      pt: "5px"
                    }}
                  >
                    <Tooltip title={IndiaWhyStudy?.point1.subtitle}>
                        {IndiaWhyStudy?.point1.title}

                        </Tooltip>
                  </Typography>
                </Card>
                <Card
                  pb={5}
                  sx={{
                    zIndex: "1",
                    borderRadius: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "250px",
                    height: "180px",
                    marginBottom: "25px",
                    padding: "20px 5px"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: {
                        sm: "80px", xs: "80px"
                      },
                      margin: "auto",
                    }}
                  >
                    <img src={Image2} alt="" width="100%" />
                  </Box>
                  <Typography
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                      fontSize: { xl: "20px", lg: "12px", md: "13px", sm: "16px", xs: "16px" }, fontWeight: 500,
                      pt: "5px"
                    }}
                  >
                    <Tooltip title={IndiaWhyStudy?.point2.subtitle}>
                        {IndiaWhyStudy?.point2.title}

                        </Tooltip>
                  </Typography>
                </Card>
                <Card
                  pb={5}
                  sx={{
                    zIndex: "1",
                    borderRadius: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "250px",
                    height: "180px",
                    marginBottom: "25px",
                    padding: "20px 5px"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: {
                        sm: "80px", xs: "80px"
                      },
                      margin: "auto",
                    }}
                  >
                    <img src={Image3} alt="" width="100%" />
                  </Box>
                  <Typography
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                      fontSize: { xl: "20px", lg: "12px", md: "13px", sm: "16px", xs: "16px" }, fontWeight: 500,
                      pt: "5px"
                    }}
                  >
                    <Tooltip title={IndiaWhyStudy?.point3.subtitle}>
                        {IndiaWhyStudy?.point3.title}

                        </Tooltip>
                  </Typography>
                </Card>
                <Card
                  pb={5}
                  sx={{
                    zIndex: "1",
                    borderRadius: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "250px",
                    height: "180px",
                    marginBottom: "25px",
                    padding: "20px 5px"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: {
                        sm: "80px", xs: "80px"
                      },
                      margin: "auto",
                    }}
                  >
                    <img src={Image4} alt="" width="100%" />
                  </Box>
                  <Typography
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                      fontSize: { xl: "20px", lg: "12px", md: "13px", sm: "16px", xs: "16px" }, fontWeight: 500,
                      pt: "5px"
                    }}
                  >
                    <Tooltip title={IndiaWhyStudy?.point4.subtitle}>
                        {IndiaWhyStudy?.point4.title}

                        </Tooltip>
                  </Typography>
                </Card>
                <Card
                  pb={5}
                  sx={{
                    zIndex: "1",
                    borderRadius: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "250px",
                    height: "180px",
                    marginBottom: "25px",
                    padding: "20px 5px"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: {
                        sm: "80px", xs: "80px"
                      },
                      margin: "auto",
                    }}
                  >
                    <img src={Image5} alt="" width="100%" />
                  </Box>
                  <Typography
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                      fontSize: { xl: "20px", lg: "12px", md: "13px", sm: "16px", xs: "16px" }, fontWeight: 500,
                      pt: "5px"
                    }}
                  >
                   <Tooltip title={IndiaWhyStudy?.point5.subtitle}>
                        {IndiaWhyStudy?.point5.title}

                        </Tooltip>
                  </Typography>
                </Card>
             
              </Box>



            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default WhyStudyInIndia;
